// Most of the file is copied from https://github.com/getsentry/sentry-javascript/blob/master/packages/gatsby/gatsby-browser.js
// with a few custom additions (such as the sentry release)

const Sentry = require('@sentry/react')
const Tracing = require('@sentry/tracing')

exports.onClientEntry = function(_, pluginParams) {
  if (pluginParams === undefined) {
    console.warn('Sentry: not loading, missing plugin params')
    return
  }

  // eslint-disable-next-line no-undef
  const env = __SENTRY_ENV__

  if (env == null || env === '') {
    console.warn('Sentry: not loading, missing environment variable')
    return
  }

  if (pluginParams.dsn == null) {
    console.warn('Sentry: not loading, missing dsn')
    return
  }

  pluginParams._metadata = pluginParams._metadata || {}
  pluginParams._metadata.sdk = {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: Sentry.SDK_VERSION,
      },
    ],
    version: Sentry.SDK_VERSION,
  }

  const integrations = [...(pluginParams.integrations || [])]

  if (
    Tracing.hasTracingEnabled(pluginParams) &&
    !integrations.some(ele => ele.name === 'BrowserTracing')
  ) {
    integrations.push(
      new Tracing.Integrations.BrowserTracing(
        pluginParams.browserTracingOptions,
      ),
    )
  }

  Tracing.addExtensionMethods()

  Sentry.init({
    autoSessionTracking: true,
    environment: env ?? 'development',
    // eslint-disable-next-line no-undef
    release: __SENTRY_RELEASE__,
    dsn: pluginParams.dsn[env],
    integrations,
  })

  window.Sentry = Sentry
}
